import { graphql } from "lib/generated/app-service-gql";
import { BuyerSupplierAwardPeriodRequest_IntervalEnum_0 as AwardsInterval } from "lib/generated/app-service-gql/graphql";
import { SupplierMentionType } from "lib/types/graphQLEnums";
import { useGraphQlQuery } from "../useGraphQlClient";

const buyerSupplierAwardPeriodNoticesQuery = graphql(`
  query buyerSupplierAwardPeriodNotices($request: BuyerSupplierAwardPeriodRequest!) {
    buyerSupplierAwardPeriodNotices(BuyerSupplierAwardPeriodRequest: $request) {
      noticeIds
    }
  }
`);

const INTERVAL: Record<Args["interval"], AwardsInterval> = {
  month: AwardsInterval.Month,
  quarter: AwardsInterval.Quarter,
  year: AwardsInterval.Year,
};

type Args = {
  buyerGuid: string;
  supplierGuid: string;
  interval: "month" | "quarter" | "year";
  /** The period's start, as the awards-over-time query returned it. */
  period: string;
  publishedFrom?: string;
  supplierMentionType: SupplierMentionType;
};

/**
 * The notices one period of the pair's awards-over-time chart counted, asked for with the chart's
 * own inputs so a list of them matches the bar.
 */
export function useBuyerSupplierAwardPeriodNotices({
  buyerGuid,
  supplierGuid,
  interval,
  period,
  publishedFrom,
  supplierMentionType,
}: Args) {
  const { data, ...rest } = useGraphQlQuery(
    [
      "buyerSupplierAwardPeriodNotices",
      buyerGuid,
      supplierGuid,
      interval,
      period,
      publishedFrom,
      supplierMentionType,
    ],
    buyerSupplierAwardPeriodNoticesQuery,
    [
      {
        request: {
          buyerGuid,
          supplierGuid,
          interval: INTERVAL[interval],
          period,
          publishedFrom,
          supplierMentionType,
        },
      },
    ],
  );

  return { data: data?.buyerSupplierAwardPeriodNotices.noticeIds, ...rest };
}
